export const CURRENT_VISIBLE_PRODUCT_ID = 'accessory_vpid';
export const LOADED_ITEMS_OFFSET = 'accessory_lio';
export const ROOT_MARGIN = '80px';
